// RESET
export const RESET = 'RESET';

// FETCH_JOBS
export const FETCH_JOBS_PENDING = 'FETCH_JOBS_PENDING';
export const FETCH_JOBS_FULFILLED = 'FETCH_JOBS_FULFILLED';
export const FETCH_JOBS_ERROR = 'FETCH_JOBS_ERROR';

// FETCH_JOB
export const FETCH_JOB_PENDING = 'FETCH_JOB_PENDING';
export const FETCH_JOB_FULFILLED = 'FETCH_JOB_FULFILLED';
export const FETCH_JOB_ERROR = 'FETCH_JOB_ERROR';

// STORE_JOB
export const STORE_JOB_PENDING = 'STORE_JOB_PENDING';
export const STORE_JOB_FULFILLED = 'STORE_JOB_FULFILLED';
export const STORE_JOB_ERROR = 'STORE_JOB_ERROR';

// DELETE_JOB
export const DELETE_JOB_PENDING = 'DELETE_JOB_PENDING';
export const DELETE_JOB_FULFILLED = 'DELETE_JOB_FULFILLED';
export const DELETE_JOB_ERROR = 'DELETE_JOB_ERROR';
